export default {
  create: 'Create',
  review: 'Review',
  approve: 'Approve',
  approved: 'Approved',
  creator: 'Creator',
  submitter: 'Submitter',
  reviewer: 'Reviewer',
  approver: 'Approver',
  create_new_payment: 'Create New Payment',
  new_payment: 'New Payment',
  edit_payment: 'Edit Payment',
  payment_details: 'Payment Details',
  create_payment_disbursement: 'Create Payment Disbursement',
  create_small_value_payment: ' Create Small-value Payment',
  create_large_value_payment: 'Create Large-value Payment',
  large_payment_min_amount: 'The payment amount cannot be less than 200,000,001',
  large_payment_max_amount: 'The payment amount cannot exceed 300,000,000',
  standard_payment_min_amount: 'The amount cannot be less than {amount}',
  single_disbursement: 'Single Disbursement',
  small_value_payment: 'Small-value Payment ',
  batch_disbursement: 'Batch Small-value Disbursement ',
  single_payment_details: 'Single Payment Details',
  recipient_account_number: 'Recipient Account Number',
  batch_payment_details: 'Batch Payment Details',
  excel_worksheet_template_excel: 'Excel Worksheet Template Excel',
  download_template: 'Download Template',
  single_payout_payment_type: 'Payment Type',
  business_detail: 'Business Detail',
  new_batch_small_disbursement: 'New Batch Small Value Disbursement',
  first_things_first: 'First things first',
  submit_batch_ease: 'Submit Batch Payments with Ease',
  step_1_title: 'Download the Latest Template:',
  step_1_content: 'Ensure you have the most recent batch payment template file. You can download it directly from the platform.',
  step_2_title: 'Fill Out Your Information:',
  step_2_content: 'Complete the template with your payment details, including recipient information and amounts.',
  step_3_title: 'Upload and Submit',
  step_3_content: 'Upload the completed template to initiate the batch payment process.',
  step_4_title: 'Download Results: ',
  step_4_content: 'Once processing is complete, a results report will be available for download on the "Batch Payment Details" page in the sidebar.'
}
